'use strict';

module.exports = [require('./reviver')];


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/json/index.js
// module id = aXdJ
// module chunks = 0